import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import Link from "next/link";

export default function SectionHeader({
  icon: Icon,
  sectionTitle,
  mainHeading,
  description,
  buttonText,
  buttonLink,
  onButtonClick,
  getLabel = (val) => val,
  buttonTarget
}) {
  return (
    <div className="flex flex-row mb-4 sm:mb-6 md:mb-8 lg:mb-10">
      <div className="flex-1 min-w-0 mr-2 sm:mr-4">
        {/* Section Badge */}
        {getLabel(sectionTitle) && Icon && (
          <div className="inline-flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full bg-primary/10 border border-primary/20 mb-2">
            <Icon className="w-3 h-3 sm:w-4 sm:h-4 text-primary" />
            <span className="font-bold text-xs sm:text-sm lg:text-sm text-primary tracking-wider truncate">
              {getLabel(sectionTitle)}
            </span>
          </div>
        )}

        {/* Main Heading */}
        {getLabel(mainHeading) && (
          <h2 className="text-sm sm:text-lg md:text-xl lg:text-xl xl:text-2xl font-bold leading-tight line-clamp-1">
            {getLabel(mainHeading)}
          </h2>
        )}

        {/* Description */}
        {getLabel(description) && (
          <p className="text-xs sm:text-sm md:text-base lg:text-base mt-2 line-clamp-2" style={{ color: 'var(--color-paragraph)' }}>
            {getLabel(description)}
          </p>
        )}
      </div>

      {/* View All Button */}
      {(buttonText || buttonLink) && (
        <div className="flex-shrink-0">
          <Button
            asChild={!!buttonLink}
            className="px-2 sm:px-4 md:px-6 py-1.5 sm:py-2.5 md:py-3 text-xs sm:text-sm md:text-base font-semibold rounded-lg transition-all duration-300 hover:scale-105"
            style={{
              backgroundColor: 'var(--color-primary)',
              color: 'var(--color-primary-foreground)',
              border: 'none'
            }}
            onClick={buttonLink ? undefined : onButtonClick}
          >
            {buttonLink ? (
              <Link href={buttonLink} target={buttonTarget || "_self"}>
                <span className="hidden sm:inline">
                  {getLabel(buttonText) || 'View All'}
                </span>
                <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4 sm:ml-2" />
              </Link>
            ) : (
              <>
                <span className="hidden sm:inline">
                  {getLabel(buttonText) || 'View All'}
                </span>
                <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4 sm:ml-2" />
              </>
            )}
          </Button>
        </div>
      )}
    </div>
  );
}